<template>
    <div id="felaktig-assistans-gemensam-sammanstallning">
        <sammanstallning-field
            :field-value="beskrivOvrigaSkal"
            text-value="impulskontrollutredning.anmalan.alla.misstanke.assistansersattning.utforsinte.alla.etikett.skaltillmisstanke"
        ></sammanstallning-field>
        <sammanstallning-field
            :field-value="hurLange"
            text-value="impulskontrollutredning.anmalan.alla.misstanke.assistansersattning.generell.alla.etikett.hurlangefelutbetalt"
        ></sammanstallning-field>
        <sammanstallning-field
            :field-value="uppgifterForsakringskassan"
            text-value="impulskontrollutredning.anmalan.alla.misstanke.assistansersattning.generell.alla.etikett.uppgifterattkontrollera"
        ></sammanstallning-field>
        <sammanstallning-field
            :field-value="andraPersoner"
            text-value="impulskontrollutredning.anmalan.alla.misstanke.assistansersattning.generell.alla.etikett.finnsandrasomkannertill"
        ></sammanstallning-field>
        <sammanstallning-field
            :field-value="ovrigInformation"
            text-value="impulskontrollutredning.anmalan.alla.misstanke.assistansersattning.generell.alla.etikett.ovriginformation"
        ></sammanstallning-field>
    </div>
</template>

<script>
import Vue from "vue";
import { mapFields } from "vuex-map-fields";
import SammanstallningField from "@/components/Kontaktuppgifter/SammanstallningField.vue";

export default Vue.extend({
    name: "FelaktigAssistansGemensamSammanstallning",
    components: {
        SammanstallningField,
    },
    computed: {
        ...mapFields([
            "observationer.assistansErsattning.beskrivOvrigaSkal",
            "observationer.assistansErsattning.hurLange",
            "observationer.assistansErsattning.uppgifterForsakringskassan",
            "observationer.assistansErsattning.andraPersoner",
            "observationer.assistansErsattning.ovrigInformation",
        ]),
    },
});
</script>
